class StringUtils {

    static isBlank(str) {
        return (!str || /^\s*$/.test(str));
    }

    static checkIfLink = (string) => {
        try {
            new URL(string)
            return true;
        } catch(err) {
            return false;
        }
    }
}

export default StringUtils;